import options from './get-width.directive';

export default {
    selector: 'getWidth',
    options
};
